import React, { useState, useEffect } from "react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import InputMask from 'react-input-mask';
import azercellbg from "../assets/image/azercellbg.webp";

const Personal = () => {
  const categories = ["Fakturasız xətt", "Fakturalı xətt", "Premium"];
  const [selectedCategory, setSelectedCategory] = useState(categories[0]);
  const [phone,setPhone] = useState('')

  const [selectedModalIndex, setSelectedModalIndex] = useState(null);
  const allTariffs = {
    "Fakturasız xətt": [
       {
        title: "DigiMax",
        description: "DigiMax tarifini seç!",
        prices: [8, 12, 18,30],
        details: {
          8: {
            internet: "3GB",
            call: "200 dəq.",
            sms:"100 SMS"
          },
          12: {
            internet: "5GB",
            call: "300 dəq.",
            sms:"150 SMS"
          },
          18: {
            internet: "10GB",
            call: "600 dəq.",
            sms: "300 SMS",
            social:"1GB",
            chat: ["whatsapp", "messenger","facebook"],
            whatsapp:"1GB",
            chat1: ["whatsapp"],
          },
          30: {
            internet: "25GB",
            call: "1500 dəq.",
            sms: "500 SMS",
            social:"3GB",
            chat: ["whatsapp", "messenger","facebook","tiktok","youtube"],
            whatsapp:"3GB",
            chat1: ["whatsapp"],
          },
        },
      },
      // {
      //   title: "SuperSən",
      //   subtitle: "Fakturasız xətt",
      //   description: "SuperSən, tarifini seç!",
        
      //   prices: [10, 15, 20, 29, 39],
      //   details: {
      //     10: {
      //       internet: "3GB",
      //       call: "300 dəq.",
      //       chat: ["whatsapp", "messenger"],
      //     },
      //     15: {
      //       internet: "6GB",
      //       call: "400 dəq.",
      //       chat: ["whatsapp", "messenger"],
      //     },
      //     20: {
      //       internet: "10GB",
      //       call: "500 dəq.",
      //       chat: ["whatsapp", "messenger"],
      //     },
      //     29: {
      //       internet: "20GB",
      //       call: "600 dəq.",
      //       chat: ["whatsapp", "messenger"],
      //     },
      //     39: {
      //       internet: "30GB",
      //       call: "700 dəq",
      //       chat: ["whatsapp", "messenger"],
      //     },
      //   },
      // },
      
      // {
      //   title: "GəncOL",
      //   subtitle: "Fakturasız xətt",
      //   description: "Gəncliyin dadını çıxar!",
      //   prices: [9, 6, 2.9],
      //   details: {
      //     9: { internet: "6GB", call: "600 dəq.", chat: ["whatsapp"] },
      //     6: { internet: "3GB", call: "300 dəq.", chat: ["whatsapp"] },
      //     2.9: { internet: "1GB", call: "100 dəq.", chat: ["whatsapp"] },
      //   },
      // },
      // {
      //   title: "Sadə",
      //   subtitle: "Fakturasız xətt",
      //   description: "Sadəcə ehtiyacın olan!",
      //   prices: [6],
      //   details: {
      //     6: { internet: "30 gun", call: "200 dəq.", chat: [] },
      //   },
      // },
    ],
    "Fakturalı xətt": [
      {
        title: "SuperSən",
        subtitle: "Fakturalı xətt",
        description: "SuperSən, tarifini seç!",
        prices: [10, 15, 20, 29, 39],
        details: {
          10: {
            internet: "3GB",
            call: "300 dəq.",
            chat: ["whatsapp", "messenger"],
          },
          15: {
            internet: "6GB",
            call: "400 dəq.",
            chat: ["whatsapp", "messenger"],
          },
          20: {
            internet: "10GB",
            call: "500 dəq.",
            chat: ["whatsapp", "messenger"],
          },
          29: {
            internet: "20GB",
            call: "600 dəq.",
            chat: ["whatsapp", "messenger"],
          },
          39: {
            internet: "30GB",
            call: "700 dəq",
            chat: ["whatsapp", "messenger"],
          },
        },
      },
    ],
    "Premium": [
      {
        title: "Premium+",
        description: "Üstünlüyü seç!",
        prices: [60, 90],
        details: {
          60: {
            internet: "60GB",
            call: "3000 dəq.",
            sms: "1500 SMS",
            social:"5GB",
            chat: ["whatsapp", "messenger","facebook","tiktok","youtube"],
            whatsapp:"5GB",
            chat1: ["whatsapp"],
            rouminq:"1GB"
          },
          90: {
            internet: "100GB",
            call: "5000 dəq.",
            sms: "2500 SMS",
            social:"10GB",
            chat: ["whatsapp", "messenger","facebook","tiktok","youtube"],
            whatsapp:"10GB",
            chat1: ["whatsapp"],
            rouminq:"3GB"
          },
        },
      },
      // {
      //   title: "Premium Fakturasız",
      //   description: "Üstünlüyü seç!",
      //   prices: [59, 79, 99],
      //   details: {
      //     59: {
      //       internet: "50GB",
      //       call: "3000",
      //       rouminq: "1GB",
      //       chat: ["whatsapp", "messenger"],
      //     },
      //     79: {
      //       internet: "75GB",
      //       call: "4000",
      //       rouminq: "2GB",
      //       chat: ["whatsapp", "messenger"],
      //     },
      //     99: {
      //       internet: "100GB",
      //       call: "5000",
      //       rouminq: "3GB",
      //       chat: ["whatsapp", "messenger"],
      //     },
      //   },
      // },
    ],
  };

  const tariffData = allTariffs[selectedCategory] || [];

  const [selectedPrices, setSelectedPrices] = useState(
    tariffData.map((tariff) => tariff.prices[0])
  );

  useEffect(() => {
    setSelectedPrices(tariffData.map((tariff) => tariff.prices[0]));
  }, [selectedCategory]);

  const handlePriceClick = (tariffIndex, price) => {
    setSelectedPrices((prev) => {
      const updated = [...prev];
      updated[tariffIndex] = price;
      return updated;
    });
  };

  return (
    <section className="personalpage" style={{ background: "#fafafa" }}>
      <div className="container-fluid">
        <div className="row mx-1">
          <span className="mt-5" style={{ opacity: "0.6" }}>
            Tariflər və xidmətlər
          </span>
          <h4 className="mt-2 mb-4" style={{ fontWeight: "bold" }}>
            {selectedCategory}
          </h4>

          <div className="d-flex my-3 flex-wrap">
            {categories.map((label, idx) => (
              <button
                key={idx}
                onClick={() => setSelectedCategory(label)}
                style={{
                  background: selectedCategory === label ? "#00C2CB" : "#fff",
                  borderRadius: "20px",
                  color: selectedCategory === label ? "#fff" : "#000",
                  padding: "10px 50px",
                  border: "1px solid #dedddd",
                  marginLeft: idx > 0 ? "12px" : "0",
                  cursor: "pointer",
                }}
              >
                {label}
              </button>
            ))}
          </div>

          {tariffData.map((tariff, idx) => {
            const selectedPrice = selectedPrices[idx];
            const detail = tariff.details[selectedPrice] || {};

            return (
              <div className="col-12 col-md-6 col-lg-4 mb-5" key={idx}>
                <div className="biznesim">
                  <div className="imgBox" style={{ position: "relative" }}>
                    <img
                      src={azercellbg}
                      alt="tariff-bg"
                      className="img-fluid"
                    />
                    <div
                      className="imgTitle"
                      style={{
                        padding: "15px",
                        position: "absolute",
                        bottom: 0,
                        left: 0,
                        right: 0,
                        color: "#fff",
                      }}
                    >
                      <div className="d-flex justify-content-between align-items-center">
                        <h5>{tariff.title}</h5>
                        <span>{tariff.subtitle}</span>
                      </div>
                      <span style={{ opacity: 0.8, fontSize: "small" }}>
                        {tariff.description}
                      </span>
                      <div
                        className="d-flex"
                        style={{
                          background: "rgba(123, 79, 154, 0.5)",
                          width:
                            tariff.prices.length >= 5
                              ? "100%"
                              : tariff.prices.length >= 3
                              ? "80%"
                              : tariff.prices.length === 2
                              ? "40%"
                              : "30%",
                          // marginTop: "10px",
                          borderRadius: "10px",
                        }}
                      >
                        {tariff.prices.map((price, i) => (
                          <button
                            key={i}
                            onClick={() => handlePriceClick(idx, price)}
                            style={{
                              background:
                                selectedPrice === price
                                  ? "#fff"
                                  : "transparent",
                              color: selectedPrice === price ? "#000" : "#fff",
                              border: "none",
                              padding: "5px",
                              borderRadius: "10px",
                              cursor: "pointer",
                              fontWeight: "bold",
                            }}
                          >
                            {price} <h6 style={{ fontSize: "small" }}>₼</h6>
                          </button>
                        ))}
                      </div>
                    </div>
                  </div>

                  {/* Detallar */}
                  <div className="details">
                    <div className="d-flex justify-content-start mt-3 ms-3 align-items-center">
                      <i className="fa-solid fa-globe me-2"></i>
                      <div>
                        <h6 style={{ margin: 0 }}>{detail.internet || "-"}</h6>
                        <p style={{ margin: 0 }}>İnternet</p>
                      </div>
                    </div>
                  </div>
                  <div className="details">
                    <div className="d-flex justify-content-start mt-3 ms-3 align-items-center">
                      <i className="fa-solid fa-phone-volume me-2"></i>
                      <div>
                        <h6 style={{ margin: 0 }}>{detail.call || "-"}</h6>
                        <p style={{ margin: 0 }}>Ölkədaxili zənglər</p>
                      </div>
                    </div>
                  </div>

                  {
                    detail.sms && (
                      <div className="details">
                      <div className="d-flex justify-content-start mt-3 ms-3 align-items-center">
                        <i className="fa-solid fa-comments me-2"></i>
                        <div>
                          <h6 style={{ margin: 0 }}>{detail.sms || "-"}</h6>
                        </div>
                      </div>
                    </div>
                    )
                  }
                  {
                    detail.social && (
                      <div className="details">
                      <div className="d-flex justify-content-between mt-3 ms-3 align-items-center">
                        <div className="d-flex align-items-center">
                          <i className="fa-solid fa-wifi me-2"></i>
                          <h6 style={{ margin: 0 }}>{detail.social  }
                          <br />
                          <span>Sosial Media</span>
                          </h6>
                          
                        </div>
                        <div>
                          {detail.chat.includes("whatsapp") && (
                            <i className="fa-brands fa-whatsapp mx-1" style={{ fontSize: "28px", color: "#25D366" }}></i>
                          )}
                          {detail.chat.includes("messenger") && (
                            <i className="fa-brands fa-facebook-messenger mx-1" style={{ fontSize: "28px", color: "#00B2FF" }}></i>
                          )}
                          {detail.chat.includes("facebook") && (
                            <i className="fa-brands fa-facebook mx-1" style={{ fontSize: "28px", color: "#1877F2" }}></i>
                          )}
                          {detail.chat.includes("tiktok") && (
                            <i className="fa-brands fa-tiktok mx-1" style={{ fontSize: "28px", color: "#000000" }}></i>
                          )}
                          {detail.chat.includes("youtube") && (
                            <i className="fa-brands fa-youtube mx-1" style={{ fontSize: "28px", color: "#FF0000" }}></i>
                          )}
                        </div>
                      </div>
                    </div>
                    )
                  }
                  {
                    detail.chat1 && detail.chat1.length > 0 && (
                      <div className="details">
                      <div className="d-flex justify-content-between mt-3 ms-3 align-items-center">
                        <div className="d-flex align-items-center">
                          <i className="fa-solid fa-mobile me-2"></i>
                          <h6 style={{ margin: 0 }}>{detail.whatsapp}
                          <br />
                          <span>Whatsapp</span>
                          </h6>
                        </div>
                        <div>
                          {detail.chat.includes("whatsapp") && (
                            <i className="fa-brands fa-whatsapp mx-1" style={{ fontSize: "28px", color: "#25D366" }}></i>
                          )}
                        </div>
                      </div>
                    </div>
                    )
                  }

                  { detail.chat && detail.chat.length > 0 && (
                    <div className={`details ${(tariff.title == "DigiMax" || tariff.title == "Premium+") ? "d-none" : "d-block"}`}>
                      <div className="d-flex justify-content-between mt-3 ms-3 align-items-center">
                        <div className="d-flex align-items-center">
                          <i className="fa-solid fa-comment-sms me-2"></i>
                          <h6 style={{ margin: 0 }}>Yazışma</h6>
                        </div>
                        <div>
                          {detail.chat.includes("whatsapp") && (
                            <i className="fa-brands fa-whatsapp mx-1" style={{ fontSize: "28px", color: "#25D366" }}></i>
                          )}
                          {detail.chat.includes("messenger") && (
                            <i className="fa-brands fa-facebook-messenger mx-1" style={{ fontSize: "28px", color: "#00B2FF" }}></i>
                          )}
                          {detail.chat.includes("facebook") && (
                            <i className="fa-brands fa-facebook mx-1" style={{ fontSize: "28px", color: "#1877F2" }}></i>
                          )}
                        </div>
                      </div>
                    </div>
                  )}

                  {detail.rouminq && (
                    <div className="details">
                      <div className="d-flex justify-content-start mt-3 ms-3 align-items-center">
                        <i className="fa-solid fa-plane me-2"></i>
                        <div>
                          <h6 style={{ margin: 0 }}>{detail.rouminq || "-"}</h6>
                          <p style={{ margin: 0 }}>Roaminq</p>
                        </div>
                      </div>
                    </div>
                  )}

                  <div className="d-flex justify-content-center align-items-center pb-3">
                    <div
                      className="d-flex justify-content-center align-items-center"
                      style={{
                        background: "#5C2483",
                        color: "#fff",
                        fontWeight: "bold",
                        width: "200px",
                        height: "40px",
                        borderRadius: "50px",
                        cursor: "pointer",
                      }}
                      onClick={() =>{
                        setSelectedModalIndex(idx)
    
                        }
                        }
                    >
                      Əlaqə
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
      {selectedModalIndex !== null && (
  <section className="modalContent" onClick={() => setSelectedModalIndex(null)}>
    <div className="modalContainer" onClick={(e) => e.stopPropagation()}>
      <div className="d-flex justify-content-between">
        <h2 style={{ fontWeight: "bold" }}>
          {tariffData[selectedModalIndex].title}
        </h2>
        <i
          className="fa-solid fa-xmark"
          onClick={() => setSelectedModalIndex(null)}
        ></i>
      </div>

      <div className="text-center">
        <span className="text-start">Mobil nömrəni daxil et :</span>
        <InputMask
          mask="+994 (99) 999 99 99"
          maskChar={null}
          className="w-100 inputMaks my-3"
          value={phone}
           onChange={(e)=>setPhone(e.target.value)}
          placeholder="+994 (__) ___ __ __"
        />
      </div>

      <a
              href={`https://wa.me/994512070940?text=${encodeURIComponent(
                `Salam, bu tariflə maraqlanıram. Zəhmət olmasa, tarif haqqında  ətraflı məlumat verin.\n\n` +
                (() => {
                  const selectedTariff = tariffData[selectedModalIndex];
                  const selectedPriceValue = selectedPrices[selectedModalIndex];
                  const selectedDetail = selectedTariff.details[selectedPriceValue];
                  return (
                    `Tarif: ${selectedTariff.title}\n` +
                    `Qiymət: ${selectedPriceValue} ₼\n` +
                    `İnternet: ${selectedDetail.internet}\n` +
                    `Zəng: ${selectedDetail.call}\n` +
                    `Əlaqə nömrəsi: ${phone && phone}`
                  );
                })()
              )}`}
        style={{
          background: "#00C2CB",
          borderRadius: "20px",
          color: "#fff",
          padding: "10px 50px",
          border: "1px solid #dedddd",
          marginLeft: "12px",
          cursor: "pointer",
          textDecoration:"none"
        }}
        onClick={() => {
          const selectedTariff = tariffData[selectedModalIndex];
          const selectedPriceValue = selectedPrices[selectedModalIndex];
          const selectedDetail = selectedTariff.details[selectedPriceValue];

       
        }}
      >
        <i className="fa-brands fa-whatsapp me-2"></i>Müraciət et
      </a>
    </div>
  </section>
)}

    </section>
  );
};

export default Personal;
